import { render, staticRenderFns } from "./WithTopNavigationLayout.vue?vue&type=template&id=6f5d50b2"
import script from "./WithTopNavigationLayout.vue?vue&type=script&lang=js"
export * from "./WithTopNavigationLayout.vue?vue&type=script&lang=js"
import style0 from "./WithTopNavigationLayout.vue?vue&type=style&index=0&id=6f5d50b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports